export enum SocialNetwork {
  Instagram = "instagram",
  Facebook = "facebook",
  TikTok = "tiktok",
  Twitter = "twitter",
}

export type SocialNetworkLinkItem = {
  name: SocialNetwork;
  url?: string;
  imgSrc: string;
  altText: string;
};
